export default __webpack_public_path__ + "static/media/atomic-assets-logo.4f716e12.png";